import api from "../services/apiService";

export const fetchMyProfile = async () => (await api.get("/profile/me")).data;
export const fetchProfile = async (userId) => (await api.get(`/profile/${userId}`)).data;
export const updateMyProfile = async (changes) => (await api.put("/profile/me", changes)).data;

export const uploadMyAvatar = async (blob, onProgress) => {
  const form = new FormData();
  form.append("photo", blob, "avatar.png");
  const { data } = await api.post("/profile/me/avatar", form, {
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  });
  return data;
};

export const removeMyAvatar = async () => (await api.delete("/profile/me/avatar")).data;
export const removeUserAvatar = async (userId) => (await api.delete(`/profile/${userId}/avatar`)).data;

export const changeMyPassword = async ({ currentPassword, newPassword, confirmPassword }) =>
  (await api.put("/profile/me/password", { currentPassword, newPassword, confirmPassword })).data;

export const fetchMyTours = async () => (await api.get("/profile/me/tours")).data;
export const completeMyTour = async (tourId, version) => (await api.put(`/profile/me/tours/${tourId}`, { version })).data;
export const resetMyTours = async () => (await api.delete("/profile/me/tours")).data;
